<template>
  <div class="introductory-training-wrapper">
    <div class="introductory-training">
      <div class="background" v-if="!training_running"></div>

      <div class="welcome-module" v-if="show_welcome">
        <img :src="welcome_training_icon">

        <div class="welcome-module-content-wrapper">
          <div>
            <div class="welcome-module-title">
              {{ $t('intro_training.welcome_aboard') }}
            </div>

            <div class="welcome-module-text">
              {{ $t('intro_training.marketing_management') }}
            </div>
          </div>

          <b-button @click="show_welcome = false; show_start = true" class="detailed" variant="link">
            {{ $t('intro_training.start') }}
          </b-button>
        </div>
      </div>

      <div class="start-module" v-if="show_start">
        <img :src="start_training_icon">

        <div class="welcome-module-content-wrapper">
          <div>
            <div class="welcome-module-title">
              {{ $t('intro_training.start_module_question') }}
            </div>

            <div class="welcome-module-text">
              <div>
                {{ $t('intro_training.control_training_buttons_text') }}
              </div>
              <div class="control-button-icons">
                <div class="esc-button">
                  Esc
                </div>

                <div class="slide-buttons">
                  <div class="left-slide-button">
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M-3.49691e-07 7L12 0.0717959L12 13.9282L-3.49691e-07 7Z" fill="#2C3236"/>
                    </svg>
                  </div>

                  <div class="right-slide-button">
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 7L6.52533e-07 0.0717959L4.68497e-08 13.9282L12 7Z" fill="#2C3236"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="button-group">
            <b-button @click="trainingEnd" class="detailed" variant="link">
              {{ $t('intro_training.later') }}
            </b-button>

            <b-button @click="show_start = false; training_running = true; nextScene()" class="detailed" variant="link">
              {{ $t('intro_training.start') }}
            </b-button>
          </div>
        </div>
      </div>

      <div class="content-hole" :style="content_hole_style" v-if="training_running"></div>

      <div class="line-wrapper" v-if="training_running" :style="description_line_style"></div>

      <div class="description-blocks-wrapper" v-if="training_running" :style="description_blocks_style">
        <div class="description-block" v-for="(scene, index) in scenario[current_frame].scene" v-if="index <= current_scene" :key="index">
          <div class="description-header">
            {{ $te(scene.title) ? $t(scene.title) : scene.title }}
          </div>

          <div class="description-body">
            <div class="description-text">
              {{ $t(scene.body) }}
            </div>

            <div :class="nextSceneButtonClass(index)" @click="nextScene">
              {{ $t('intro_training.next') }}
            </div>
          </div>
        </div>
      </div>

      <b-button class="continue-later detailed" @click="trainingEnd" v-if="training_running" variant="link">
        {{ $t('intro_training.continue_later') }}
      </b-button>
    </div>
  </div>
</template>

<script>
let welcome_training = require('@/assets/welcome_training.svg')
let start_training = require('@/assets/start_training.svg')

export default {
  name: 'IntroductoryTraining',
  data () {
    return {
      show_welcome: true,
      show_start: false,
      training_running: false,
      welcome_training_icon: welcome_training,
      start_training_icon: start_training,
      current_frame: null,
      current_scene: null,
      scenario: [
        {
          frame_selector: '#menu-leads',
          frame_offset: {
            left: 2,
            top: 2,
            width: 4,
            height: 4
          },
          scene_styles: {
            top: '200px',
            left: '250px',
            display: 'flex',
            flexWrap: 'wrap'
          },
          scene: [
            {
              title: '1',
              body: 'intro_training.scene_leads_first_text'
            },
            {
              title: '2',
              body: 'intro_training.scene_leads_second_text'
            },
            {
              title: '3',
              body: 'intro_training.scene_leads_third_text'
            },
          ]
        },
        {
          frame_selector: '#menu-instruments',
          frame_offset: {
            left: 2,
            top: 2,
            width: 4,
            height: 4
          },
          scene_styles: {
            top: '200px',
            left: '250px',
            display: 'flex',
            flexWrap: 'wrap'
          },
          scene: [
            {
              title: '1',
              body: 'intro_training.scene_instruments_first_text'
            },
            {
              title: '2',
              body: 'intro_training.scene_instruments_second_text'
            },
            {
              title: '3',
              body: 'intro_training.scene_instruments_third_text'
            },
          ]
        },
        {
          frame_selector: '#menu-reports',
          frame_offset: {
            left: 2,
            top: 2,
            width: 4,
            height: 4
          },
          scene_styles: {
            top: '200px',
            left: '250px',
            display: 'flex',
            flexWrap: 'wrap'
          },
          scene: [
            {
              title: '1',
              body: 'intro_training.scene_reports_first_text'
            },
            {
              title: '2',
              body: 'intro_training.scene_reports_second_text'
            },
            {
              title: '3',
              body: 'intro_training.scene_reports_third_text'
            },
          ]
        },
        {
          frame_selector: '#menu-analytics',
          frame_offset: {
            left: 2,
            top: 2,
            width: 4,
            height: 4
          },
          scene_styles: {
            top: '200px',
            left: '250px',
            display: 'flex',
            flexWrap: 'wrap'
          },
          scene: [
            {
              title: '1',
              body: 'intro_training.scene_analytics_first_text'
            },
            {
              title: '2',
              body: 'intro_training.scene_analytics_second_text'
            },
            {
              title: '3',
              body: 'intro_training.scene_analytics_third_text'
            },
          ]
        },
        {
          frame_selector: '.color-theme-switcher',
          frame_offset: {
            left: 6,
            top: 21,
            width: 12,
            height: 35
          },
          scene_styles: {
            top: '130px',
          },
          scene: [
            {
              title: 'intro_training.scene_color_switcher_title',
              body: 'intro_training.scene_color_switcher_text'
            },
          ]
        }
      ],
      settings_scene: {
        frame_selector: '#settings-icon',
        frame_offset: {
          left: 18,
          top: 27,
          width: 36,
          height: 42
        },
        scene_styles: {
          top: '130px'
        },
        scene: [
          {
            title: 'intro_training.scene_settings_title',
            body: 'intro_training.scene_settings_text'
          },
        ]
      },
    }
  },
  created () {
    if(this.$store.getters.getUserData && this.$store.getters.getUserData.permissions.includes('manage_users')) {
      this.scenario.push(this.settings_scene)
    }
  },
  mounted () {
    window.addEventListener('resize', this.correctStyleOnResize)
    document.addEventListener('keydown', this.slideSceneArrows)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.correctStyleOnResize)
    document.removeEventListener('keydown', this.slideSceneArrows)

    this.$emit('destroyed')
  },
  watch: {
    training_running () {
      if(this.training_running) {
        document.body.style.overflow = 'hidden'
      }
      else {
        document.body.style.overflow = 'auto'
      }
    }
  },
  computed: {
    content_hole_style () {
      if(!this.scenario[this.current_frame]) return
      let element = document.querySelector(this.scenario[this.current_frame].frame_selector)
      if(!element) return
      let data = element.getBoundingClientRect()
      if(!data) return

      let offest = this.scenario[this.current_frame].frame_offset || {
        left: 2,
        top: 2,
        width: 4,
        height: 4
      }

      return {
        left: `${data.left - offest.left}px`,
        top: `${data.top - offest.top}px`,
        width: `${data.width + offest.width}px`,
        height: `${data.height + offest.height}px`
      }
    },
    description_blocks_style () {
      if(!this.scenario[this.current_frame]) return

      let scene_style = JSON.parse(JSON.stringify(this.scenario[this.current_frame].scene_styles))

      if(!scene_style.hasOwnProperty('top')) {
        scene_style.top = this.content_hole_style.top
      }
      if(!scene_style.hasOwnProperty('left')) {
        scene_style.left = this.content_hole_style.left
      }

      if(this.scenario.length - 1 === this.current_frame && this.$store.getters.getUserData && this.$store.getters.getUserData.permissions.includes('manage_users')) {
        let left = parseInt(scene_style.left.split('px')[0])
        scene_style.left = `${left + 54 - 320}px`
      }

      return scene_style
    },
    description_line_style () {
      let styles = {}
      if(this.current_frame <= 3) {
        styles.top = this.content_hole_style.top
        styles.left = parseInt(this.content_hole_style.left.split('px')[0]) + parseInt(this.content_hole_style.width.split('px')[0]) + 5 + 'px'
        styles.width = parseInt(this.description_blocks_style.left.split('px')[0]) - parseInt(styles.left.split('px')[0]) - 10 + 'px'
        styles.borderTop = '1px dashed #7340F7'
      }
      else {
        styles.top = parseInt(this.content_hole_style.height.split('px')[0]) + 5 + 'px'
        styles.height = parseInt(this.description_blocks_style.top.split('px')[0]) - parseInt(this.content_hole_style.height.split('px')[0]) - 10 + 'px'
        styles.borderLeft = '1px dashed #7340F7'

        if(this.current_frame === 4) {
          styles.left = this.content_hole_style.left
        }
        else if(this.current_frame === 5) {
          styles.left = parseInt(this.content_hole_style.left.split('px')[0]) + parseInt(this.content_hole_style.width.split('px')[0]) + 'px'
        }
      }
      return styles
    }
  },
  methods: {
    correctStyleOnResize () {
      if(!this.training_running || this.current_frame === null) return

      if(this.scenario.length - 1 === this.current_frame) {
        this.current_frame--
        this.current_frame++
      }
      else {
        this.current_frame++
        this.current_frame--
      }
    },
    nextSceneButtonClass (index) {
      if(this.current_scene === index) {
        return 'scene-next'
      }
      else {
        return 'scene-next disabled'
      }
    },
    nextScene () {
      if(this.current_frame === null) {
        this.current_frame = 0
        this.current_scene = 0
      }
      else if(!this.scenario[this.current_frame].scene[this.current_scene + 1]) {
        if(this.scenario[this.current_frame + 1]) {
          this.current_frame++
          this.current_scene = 0
        }
        else {
          this.trainingEnd()
        }
      }
      else {
        this.current_scene++
      }
    },
    prevScene () {
      if(!this.scenario[this.current_frame].scene[this.current_scene - 1]) {
        if(this.scenario[this.current_frame - 1]) {
          this.current_frame--
          this.current_scene = this.scenario[this.current_frame].scene.length - 1
        }
        else {
          this.trainingEnd()
        }
      }
      else {
        this.current_scene--
      }
    },
    trainingEnd () {
      this.current_frame = 0
      this.current_scene = 0
      this.$parent.education_mode = false
    },
    slideSceneArrows (event) {
      if(this.training_running) {
        if(event.key === 'ArrowRight') {
          this.nextScene()
        }
        else if(event.key === 'ArrowLeft') {
          this.prevScene()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.introductory-training-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  color: #212529 !important;
  z-index: 100;

  .introductory-training {
    width: 100%;
    height: 100%;
    position: relative;

    .background {
      width: 100%;
      height: 100%;
      position: absolute;
      background: rgba(255, 255, 255, 0.8);
    }
    .welcome-module, .start-module {
      border: 1px solid #FF4402;
      box-shadow: 4px 4px 4px rgba(44, 50, 54, 0.25);
      border-radius: 3px;
      background: white;
      position: absolute;
      padding: 15px 40px;
      display: flex;
      width: 750px;
      height: 450px;
      justify-content: space-between;
      top: calc(50% - 225px);
      left: calc(50% - 375px);

      .welcome-module-content-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        text-align: right;

        .welcome-module-title {
          font-size: 30px;
          margin-bottom: 15%;
        }
        .welcome-module-text {
          font-size: 22px;

          .control-button-icons {
            display: flex;
            justify-content: flex-end;
            margin-top: 20px;

            .esc-button, .slide-buttons > div {
              border: 1px solid #CFD0D1;
              border-radius: 3px;
              width: 60px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .slide-buttons {
              margin-left: 50px;
              display: flex;

              div:first-child {
                margin-right: 15px;
              }
            }
          }
        }
        .btn.detailed.btn-link {
          width: 120px;
          margin-bottom: 40px;
        }
      }
      .button-group {
        button:last-child {
          margin-left: 20px;
        }
      }
    }
    .content-hole {
      position: absolute;
      box-shadow: 0 0 0 99999px rgba(250, 250, 250, 0.8);
      border: 3px solid #7340F7;
      border-radius: 3px;
    }
    .line-wrapper {
      position: absolute;
    }
    .description-blocks-wrapper {
      position: absolute;

      .description-block {
        border: 3px solid #7340F7;
        border-radius: 3px;
        padding: 10px 20px;
        background: #FFFFFF;
        margin-right: 20px;
        margin-bottom: 20px;

        width: 320px;
        height: 280px;

        .description-header {
          border-bottom: 1px solid #7340F7;
          text-align: center;
          padding-bottom: 5px;
          font-size: 18px;
          margin-bottom: 20px;
        }
        .description-body {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: calc(100% - 53px);

          .scene-next {
            text-decoration: underline;
            color: #7340F7;
            text-align: right;
            cursor: pointer;
          }
          .scene-next.disabled {
            color: #CFD0D1;
            pointer-events: none;
          }
        }
      }
    }
    .continue-later {
      position: absolute;
      bottom: 100px;
      right: 100px;
      background: #FF4402;
      color: white;
    }
  }
}

.color-theme-dark {
  .introductory-training-wrapper {
    .btn.detailed.btn-link {
      color: #212529 !important;
      border: 1px solid #FF4402 !important;
    }
    .btn.detailed.btn-link:hover {
      background: #FF4402 !important;
      color: white !important;
    }
    .btn.detailed.btn-link:active {
      box-shadow: 0 0 0 0.2rem rgba(255, 68, 2, 0.5) !important;
    }
    .btn.continue-later.detailed.btn-link {
      color: white !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/IntroductoryTraining.vue